import { MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import React from "react";
import { useImmer } from "use-immer";
import { GroupedEntityType } from "~/gql/graphql";
import { CreateGroupItemModal } from "./create-group-item-modal";

type Item = {
  id: number;
  name: string;
};

type GroupItemActionListProps<T> = {
  item: T;
  onCreate: (payload: { name: string; parentId: number }) => void;
  groupEntityType: GroupedEntityType;
};

type ModalState = {
  showModal: boolean;
  modalItem?: Item;
};

export const GroupItemActionList = <T extends Item>({
  item,
  groupEntityType,
}: GroupItemActionListProps<T>) => {
  const [modalState, setModalState] = useImmer<ModalState>({
    showModal: false,
  });

  return (
    <>
      <Dropdown
        key={item.id}
        menu={{
          items: [
            {
              label: (
                <div
                  onClick={() =>
                    setModalState((draft) => {
                      draft.showModal = true;
                      draft.modalItem = undefined;
                    })
                  }
                  style={{ padding: 5 }}
                >
                  Create Subgroup
                </div>
              ),
              key: `active-${item.id}`,
            },
            {
              label: (
                <div
                  onClick={() =>
                    setModalState((draft) => {
                      draft.showModal = true;
                      draft.modalItem = item;
                    })
                  }
                  style={{ padding: 5 }}
                >
                  Edit Group
                </div>
              ),
              key: `edit-${item.id}`,
            },
          ],
        }}
        trigger={["click"]}
      >
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            <MoreOutlined style={{ padding: "5px" }} />
          </Space>
        </a>
      </Dropdown>
      {modalState.showModal && (
        <CreateGroupItemModal
          parentId={item.id}
          groupItemEntityType={groupEntityType}
          setModalState={(newState) => {
            setModalState((draft) => {
              draft.showModal = newState;
            });
          }}
          item={modalState.modalItem}
        />
      )}
    </>
  );
};
